module.exports = "/_next/static/images/img-about-hero-large-c643b5da0d4ef490e5f2f633e455bd55.jpg";